import { creatorbase, creatorbaseQueries } from '@round/api';
import { useCallback } from 'react';
import { useCreatePost, useInvalidatePosts } from '@round/creatorbase-helpers/api-hooks';
import { showNotification } from 'helpers';
import useRefreshProjectCampaignStats from '../useRefreshProjectCampaignStats';
import { getProjectDetailsPostsParams } from './getProjectDetailsPostsParams';

export default function useCreateProjectDetailsPost() {
    const invalidatePosts = useInvalidatePosts();
    const refreshAllStats = useRefreshProjectCampaignStats();

    const { createAsync } = useCreatePost({
        onSuccess: (createdPost: creatorbase.Post) => {
            invalidatePosts(getProjectDetailsPostsParams(createdPost.campaign_id));
            refreshAllStats(createdPost.campaign_id, createdPost.platform).catch(() => {
                showNotification('Could not refresh data', 'error');
            });
        },
    });

    const createPost: typeof creatorbase.postPost = useCallback(
        async (data) => {
            try {
                const createdPost = await createAsync(data);
                return { status: 201, data: createdPost };
            } catch (error) {
                if (error instanceof Error && creatorbaseQueries.posts.utils.create.isExpectedErrorResponse(error)) {
                    return error.response;
                }

                throw error;
            }
        },
        [createAsync]
    );

    return { createPost };
}
